import { IAppState } from 'shared/common/state';

export function isNewbuildingSelector(state: IAppState) {
  return state.isNewbuildingsOnly;
}
